import React, { ChangeEvent, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { IStudent } from '../../models/student';
import { Col, Form } from "react-bootstrap";
import './memorization-container.css';
import { Chapters } from '../../consts/surah-const';
import { IMemorizationChapter } from '../../models/memorization-chapter';
import { MemorizationChapterTable } from './memorization-chapter-table';
import { IMemorization } from '../../models/memorization';
import { MemorizationChapterOptionStatus, MemorizationStatus } from '../../enums/status-enums';
import { ITeacher } from '../../models/teacher';
import { UserHasRoles } from '../../user/role';
import { useUserContext } from '../../user/user-context';
import MemorizationChapterOptionModal from './memorization-chapter-option-modal';

export interface IMemorizationHomeWorkModal {
   onCreateMemorizationHomeWork: (memorization: IMemorization) => void;
   student: IStudent;
   teacher: ITeacher;
   hasUncompletedMemorizationHomeWork: boolean;
   lastFinishedMemorization: IMemorization;
}

function MemorizationHomeWorkModal(props: IMemorizationHomeWorkModal) {

   const {student, teacher, onCreateMemorizationHomeWork, 
    hasUncompletedMemorizationHomeWork, lastFinishedMemorization} = props;

   const [show, setShow] = useState(false);
   const [memorizationChaptersState, setMemorizationChapters] = useState([] as IMemorizationChapter[]);

   const {userContext} = useUserContext();

   const handleClose = () => 
   {
      setShow(false);
      setMemorizationChapters([]);
   };

   const handleShow = () => setShow(true);

  const handleChangeMemorizationChapter = (memorizationChapter: IMemorizationChapter)=> {
    setMemorizationChapters(
      memorizationChaptersState.map(mc => 
        mc.chapterId === memorizationChapter.chapterId && mc.memorizationType === memorizationChapter.memorizationType
        ? memorizationChapter 
        : mc)
    )
  }

  const handleCreateMemorizationHomeWork = () => {
    const memorization = {
          memorizationChapters: memorizationChaptersState,
          student: student,
          teacher: teacher
    } as IMemorization;
    onCreateMemorizationHomeWork(memorization);
    setShow(false);
    setMemorizationChapters([]);
  }

  const handleUpdateMemorizationChapters = (memorizationChapters: IMemorizationChapter[]) => {
    setMemorizationChapters(memorizationChapters);
  }


  return (
      <>
      {!hasUncompletedMemorizationHomeWork && UserHasRoles(userContext,["Administrator","Teacher"]) && <label style={{
            marginTop:"10px",
            marginBottom: "10px",  
            marginLeft: "16px", 
            fontFamily: 'Heiti SC, sans-serif',
            fontWeight: "500",
            fontSize:"18px",
            color:"#000"}}>Min memorering og repetition</label>}

       <br></br>
       {!hasUncompletedMemorizationHomeWork && UserHasRoles(userContext,["Administrator","Teacher"]) &&
        <Button style={{
          backgroundColor:"#197770",
          marginLeft: "12px", 
          fontWeight: "400",
          fontFamily: 'Heiti SC, sans-serif',
          marginBottom: "16px"}} variant="primary" onClick={handleShow}>
          Opret lektie
        </Button>}

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title  style={{  fontFamily: 'Heiti SC, sans-serif',
            fontWeight: "400",
            fontSize:"20px",
            color:"#000"}}>Opret lektie</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <div>
         <div>
              <div style={{marginBottom: "20px"}}>
                <label style={{marginBottom: "10px" , fontFamily: 'Heiti SC, sans-serif'}}>Surah:
                </label>
                {
                  <MemorizationChapterOptionModal 
                      memorizationChapters={memorizationChaptersState}
                      onUpdateMemorizationChapters={handleUpdateMemorizationChapters}
                      memorizationChapterOptionStatus= {MemorizationChapterOptionStatus.New}
                      lastFinishedMemorization ={lastFinishedMemorization} />
                 }
              </div>
              <div>
                <MemorizationChapterTable memorizationChapters={memorizationChaptersState}
                onChangeMemorizationChapter = {handleChangeMemorizationChapter} />
              </div>
          </div>
          <br></br>
          </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary"  style={{backgroundColor:"#197770",  fontFamily: 'Heiti SC, sans-serif'}} onClick={handleClose}>
              Luk
            </Button>
             <Button variant="primary" style={{backgroundColor:"#197770",  fontFamily: 'Heiti SC, sans-serif'}} onClick={handleCreateMemorizationHomeWork}>
              Opret lektie
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
}

export default MemorizationHomeWorkModal;